export default __webpack_public_path__ + "static/media/check.911a9289.png";